import * as React from "react";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import { IconButton,Alert } from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";


export default function PositionedSnackbar({ value, setshow, text, severity }) {
  const [state, setState] = React.useState({
    vertical: "top",
    horizontal: "center",
  });

  const { vertical, horizontal } = state;

  const handleClose = () => {
    setState({ ...state });
    setshow(false);
  };

  const action = (
    <div className=" text-white">
      <React.Fragment>
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
        >
          <AiOutlineClose size={20} className="text-white" />
        </IconButton>
      </React.Fragment>
    </div>
  );

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={value}
        onClose={handleClose}
        autoHideDuration={2000}
        key={vertical + horizontal}
        action={action}
      >
        <Alert onClose={handleClose} severity={severity} variant="filled" sx={{ width: "100%" }}>
        {text}
        </Alert>
      </Snackbar>
    </div>
  );
}
